/*
    THIS FILE IS OWNED BY "NO PAIN NO MAIN"
*/
export enum ProgramManagementFeatureFlags {
    EnableFilteredFacilityExport = 'ENABLE_JOB_INFO_REPOSITORY_GET_FACILITIES_SECONDARY_SORT_BY_ID',
    WorkingCandidatesGridExtensionRequestShowBlueE = 'WORKING_CANDIDATES_GRID_CANDIDATE_EXTENSION_REQUESTED_SHOW_BLUE_E',
    ShowExtensionRequestsInRecruiterDashboard = 'SHOW_EXTENSION_REQUESTS_IN_RECRUITER_DASHBOARD',
    UseNewJobImporter = 'USE_NEW_JOB_IMPORTER',
    ShowSubmittalsInAmJobsGrid = 'view-submittals-am-jobs-grid',
    NeonTigerShiftScheduleSupport = 'nt-shift-schedule-support',
    ReflectiveOnionEnableContacts = 'reflective-onion-enable-contacts',
    UpdatePositionClosingReasonList = 'update-position-closing-reason-list',
    EnableBulkEditJobPanel = 'enable-bulk-edit-job-panel',
    HideSaveCancelButtonsForNewJobs = 'hide-save-cancel-buttons-for-new-jobs',
    NeonTigerUseNewVendorFilters = 'neon-tiger-use-new-vendor-filters',
    EnableLegacyFacilityProfilesTab = 'enable-legacy-facility-profiles-tab',
    SendToClientEnableUniversalContacts = 'send-to-client-enable-universal-contacts',
    RemoveFreeTextFiltersFromJobsGrid = 'nova-am-jobs-remove-free-text-filters',
    AmJobsBulkEditFixAcceptingNewGrads = 'am-jobs-bulk-edit-fix-accepting-new-grads',
    EnableJobTransformation = 'transformer-jobs-backend-support',
    UniversalContactsUnitPriorityFix = 'reflective-onion-unit-contact-priority-fix',
    DisplayPristineFacilityColumnInFacilityGrid = 'display-pristine-facility-column-in-facility-grid',
    EnableExtendedContactNameChars = 'enable-extended-contact-name-chars',
    ReflectiveOnionFixImportRequiredError = 'reflective-onion-show-required-errors-on-migrate',
    NovaContactsUnitLinkingPreviewTrackingFix = 'nova-contacts-unit-linking-preview-tracking-fix',
    ReflectiveOnionFixContactPicker = 'reflective-onion-contact-picker-fix',
    EnableContactServiceLinking = 'enable-contact-service-linking'
}
